import { startNexusDemoJourneySummaryStreamLoop } from './nexusDemoJourneySummaryStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} NexusJourneySummaryStreamCtx
 */

/** @param {NexusJourneySummaryStreamCtx} ctx */
export function runNexusDemoJourneySummaryStream(ctx) {
  startNexusDemoJourneySummaryStreamLoop(ctx)
}
